import { IconType } from 'components/Icon';
import forge from 'apis/forge';
import { SceneDsLink } from 'dragonmouse-shared/interfaces';
import { toast } from 'react-toastify';
import { DesignSystemSection } from './types';

// Tab chrome (icon + label) per DS section.
export const DS_TAB_CHROME: Record<
	DesignSystemSection,
	{
		icon: IconType;
		label: string;
	}
> = {
	foundations: { icon: IconType.STACK_LINE, label: 'Foundations' },
	guidelines: { icon: IconType.BOOK_OPEN, label: 'Guidelines' },
	theme: { icon: IconType.PALETTE, label: 'Theme' },
	styles: { icon: IconType.CONTRAST_DROP, label: 'Styles' },
	components: { icon: IconType.PUZZLE2, label: 'Components' },
	gallery: { icon: IconType.LAYOUT, label: 'Gallery' },
	assets: { icon: IconType.ATTACHMENT_2, label: 'Assets' },
};

// Fetches a SceneDsLink for a design system: the DS itself, the best usable published
// version, and the latest published version number. Toasts and returns null on failure.
export const fetchSceneDsLink = async (designSystemId: string): Promise<SceneDsLink | null> => {
	try {
		return await forge.getSceneDsLink(designSystemId);
	} catch (error: any) {
		const message = error?.response?.data?.error;
		if (message?.includes('no published version')) {
			toast.warning(
				'This design system has no published version yet. If you just created it, please wait a couple of minutes and try again.'
			);
		} else if (message?.includes('failed to publish')) {
			toast.warning('This design system failed to publish. Please try publishing again.');
		} else if (message?.includes('not ready')) {
			toast.warning(
				'This design system is not ready for use yet. Please wait a couple of minutes and try again.'
			);
		} else {
			console.error('Failed to fetch design system link:', error);
			toast.error('Failed to load design system. Please try again.');
		}
		return null;
	}
};
